<template>
  <section id="global-variables-list" class="!px-3">
    <el-tabs
      class="items-container sidemenu heightClass"
      v-model="selectedTab"
      :tab-position="getIsMobile ? 'top' : 'left'"
      @tab-click="onClickPanel"
      v-loading="loading"
    >
      <el-tab-pane label="All Categories" name="All Categories">
        <div
          class="!p-3 !pt-0 !mt-3 !border border-black/10 rounded-xl h-[calc(100vh-200px)] lg:!h-[calc(100vh-150px)] overflow-y-auto"
        >
          <div class="!py-3 border-b border-black/10 sticky top-0 bg-white z-[1]">
            <div
              class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4"
            >
              <h2
                class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
              >
                Global Variables
              </h2>
              <div
                class="flex items-center justify-start md:!justify-end !gap-3 flex-wrap md:!flex-nowrap flex-1"
              >
                <el-input
                  placeholder="Search"
                  prefix-icon="el-icon-search"
                  size="mini"
                  v-model="search_string"
                  @keyup.enter.native="fetchAllGlobalVariables()"
                  :style="getismobile ? 'width:160px;' : 'width: 170px'"
                  clearable
                ></el-input>
                <el-button
                  style="background: var(--brand-500) !important"
                  class="!py-1.5 !px-4 !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto"
                  type="primary"
                  @click="navigate"
                >
                  <span class="flex items-center !gap-1.5">
                    <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
                    <span class="text-xs font-light text-white">
                      {{ getIsMobile ? 'New' : 'New Variable' }}
                    </span>
                  </span>
                </el-button>
              </div>
            </div>
          </div>
          <div class="!pt-3 !mb-4 min-h-[50vh]">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="!pb-3" id="breadcrumb">
              <el-breadcrumb-item>
                <a @click="goToDashBoard()" class="text-xs 2xl:text-smd !font-normal text-black">
                  Dashboard
                </a>
              </el-breadcrumb-item>
              <el-breadcrumb-item class="!text-brand-500 text-xs 2xl:text-smd font-normal">
                Global Variables
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="gridCols-4 gap-3">
              <div class="single-cell p-3" v-for="(variable, index) of data" :key="index">
                <h4 class="!text-black-950 !font-normal !text-[13px] 2xl:!text-base !m-0 !mb-4">
                  {{ variable.label }}
                </h4>
                <div class="flex items-end justify-between">
                  <span class="flex flex-col !gap-1.5">
                    <span class="!text-black-950 font-normal text-[13px] 2xl:!text-sm">
                      Category
                    </span>
                    <el-tag
                      class="!bg-transparent hover:!bg-brand-100 !border-brand-500 !text-brand-500 !px-3 !py-1 !rounded-md text-xxs 2xl:!text-xs !font-normal cursor-pointer !mb-0 !h-auto !leading-normal"
                      size="small"
                    >
                      {{ variable.input_type }}
                    </el-tag>
                  </span>
                  <div class="flex items-center">
                    <el-tooltip effect="dark" content="Duplicate" placement="top">
                      <el-button
                        icon="el-icon-copy-document"
                        plain
                        type="danger"
                        circle
                        size="mini"
                        @click="onDuplicate(variable)"
                      ></el-button>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="View and Edit" placement="top">
                      <el-button
                        class="!border !border-brand-500 !bg-brand-50 !text-brand-500 hover:!text-white hover:!bg-brand-500"
                        icon="el-icon-view"
                        @click="onEdit(variable)"
                        plain
                        circle
                        size="mini"
                      ></el-button>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="Delete" placement="top">
                      <el-button
                        icon="el-icon-delete"
                        @click="onDelete(variable)"
                        type="secondary"
                        plain
                        circle
                        size="mini"
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            class="!flex items-center justify-center"
            @size-change="loadData"
            @current-change="loadData"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="getTabLabelName(type)"
        :name="type"
        v-for="(type, index) of filteredGlobalVariableTypes"
        v-bind:key="index"
      >
        <div
          class="!p-3 !pt-0 !border border-black/10 rounded-xl h-[clac(100vh-200px)] lg:!h-[calc(100vh-150px)] !overflow-y-auto !mt-3"
        >
          <div class="!py-3 border-b border-black/10 sticky top-0 bg-white z-[1]">
            <div
              class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4"
            >
              <h2
                class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
              >
                Global Variables
              </h2>
              <div
                class="flex items-center justify-start md:!justify-end !gap-3 flex-wrap md:!flex-nowrap flex-1"
              >
                <el-input
                  placeholder="Search"
                  prefix-icon="el-icon-search"
                  size="mini"
                  v-model="search_string"
                  @keyup.enter.native="fetchAllGlobalVariables()"
                  :style="getismobile ? 'width:160px;' : 'width: 170px'"
                  clearable
                ></el-input>
                <el-button
                  style="background: var(--brand-500) !important"
                  class="!py-1.5 !px-4 !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto"
                  type="primary"
                  @click="navigate"
                >
                  <span class="flex items-center !gap-1.5">
                    <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
                    <span class="text-xs font-light text-white">
                      {{ getIsMobile ? 'New' : 'New Variable' }}
                    </span>
                  </span>
                </el-button>
              </div>
            </div>
          </div>
          <div class="!pt-3 !mb-4 min-h-[50vh]">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="!pb-3" id="breadcrumb">
              <el-breadcrumb-item>
                <a @click="goToDashBoard()" class="text-xs 2xl:text-smd !font-normal text-black">
                  Dashboard
                </a>
              </el-breadcrumb-item>
              <el-breadcrumb-item class="!text-brand-500 text-xs 2xl:text-smd font-normal">
                Global Variables
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="gridCols-4 gap-3">
              <div class="single-cell p-3" v-for="(variable, index) of data" :key="index">
                <h4 class="!text-black-950 !font-normal !text-[13px] 2xl:!text-base !m-0 !mb-4">
                  {{ variable.label }}
                </h4>
                <div class="flex items-end justify-between">
                  <span class="flex flex-col !gap-1.5">
                    <span class="text-black-950 font-normal text-[13px] 2xl:!text-sm">
                      Category
                    </span>
                    <el-tag
                      class="!bg-transparent hover:!bg-brand-100 !border-brand-500 !text-brand-500 !px-3 !py-1 !rounded-md text-xxs 2xl:!text-xs !font-normal cursor-pointer !mb-0 !h-auto !leading-normal"
                      size="small"
                    >
                      {{ variable.input_type }}
                    </el-tag>
                  </span>

                  <div class="flex items-center">
                    <el-tooltip effect="dark" content="Duplicate" placement="top">
                      <el-button
                        icon="el-icon-copy-document"
                        plain
                        type="globalvariable"
                        circle=""
                        size="mini"
                        @click="onDuplicate(variable)"
                      ></el-button>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="Edit" placement="top">
                      <el-button
                        icon="el-icon-view"
                        @click="onEdit(variable)"
                        type="globalvariable"
                        plain
                        circle
                        size="mini"
                      ></el-button>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="Delete" placement="top">
                      <el-button
                        icon="el-icon-delete"
                        @click="onDelete(variable)"
                        type="globalvariable"
                        plain
                        circle
                        size="mini"
                      ></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- Display None (D-NONE) -->
    <div class="inner-navbar-content top d-none">
      <div class="vue-data-table-default">
        <data-tables-server
          :data="data"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading"
        >
          <el-table-column label="Variable" id="category" width="300" fixed="left">
            <template slot-scope="scope">{{ scope.row.label }}</template>
          </el-table-column>

          <el-table-column label="Type" id="name" width="240">
            <template slot-scope="scope">{{ scope.row.input_type }}</template>
          </el-table-column>

          <el-table-column label="Data" id="name" min-width="240">
            <template slot-scope="scope">{{ scope.row.value }}</template>
          </el-table-column>

          <el-table-column prop="action" label="Action" fixed="right" width="120">
            <template slot-scope="scope">
              <ul class="action-buttons">
                <li>
                  <el-button>
                    <img
                      src="@/assets/img/icons/visibility.svg"
                      alt="icon"
                      @click="onView(scope.row)"
                    />
                  </el-button>
                </li>
                <li>
                  <el-button>
                    <img
                      src="@/assets/img/icons/delete.png"
                      alt="icon"
                      @click="onDelete(scope.row)"
                    />
                  </el-button>
                </li>
              </ul>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import { fetchGlobalVariables, deleteGlobalVariable } from '@/repo/globalVariables';
  export default {
    name: 'GlobalVariablesList',
    components: {},
    data() {
      return {
        loading: false,
        total: 0,
        currentPage: 1,
        pageSize: 0,
        data: [],
        tabPosition: 'left',
        search_string: '',
        selectedTab: 'All Categories',
      };
    },
    mixins: [PermissionsHelper],
    computed: {
      ...mapGetters('globalVariables', [
        'getAllGlobalVariables',
        'getGlobalVariableDeleteStatus',
        'getGlobalVariableAddStatus',
        'getGlobalVariableDeleteError',
        'getUserDeleteError',
        'getAllGlobalVariableTypes',
      ]),
      ...mapGetters('navigationOpen', ['getIsMobile']),
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 20, 50],
        };
      },
      queryType() {
        return this.$route.query.type || this.selectedTab;
      },
      filteredGlobalVariableTypes() {
        return (this.getAllGlobalVariableTypes?.data || []).filter(
          (type) => type !== 'QUESTION' && type !== 'ACTION_BUTTON'
        );
      },
    },
    async mounted() {
      // this.fetchAllGlobalVariableTypes();
      let limit = this.pageSize > 0 ? this.pageSize : 10;
      this.pageSize = limit;
      if (
        this.getGlobalVariableAddStatus &&
        this.$route &&
        this.$route.query &&
        this.$route.query.type
      ) {
        this.selectedTab = this.queryType;
      }

      // if (this.$route.query.search) {
      //   this.searchString = this.$route.query.search;
      // }
      this.fetchAllGlobalVariables();
    },
    methods: {
      navigate() {
        if (this.checkPermissionByPermissionName('addGlobalVariables')) {
          this.$router.push('/global-variables/add');
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied. Please contact Owner.',
          });
        }
      },
      goToDashBoard() {
        this.$router.push({
          path: '/',
        });
      },
      async fetchAllGlobalVariableTypes() {
        await this.$store.dispatch('globalVariables/fetchGlobalVariableTypes');
      },

      // Mukesh Duplicate Global Variable Feature

      onDuplicate(variable) {
        this.$router.push({
          name: 'UpdateGlobalVariable',
          params: {
            global_variable_id: variable._id,
          },
          query: {
            global_variable_action: 'duplicateGlobalVariable',
          },
        });
      },

      // Mukesh Duplicate Global Variable Feature

      onEdit(variable) {
        if (this.checkPermissionByPermissionName('globalVariableView')) {
          this.$router.push({
            name: 'UpdateGlobalVariable',
            params: {
              global_variable_id: variable._id,
            },
          });
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied. Please contact Owner.',
          });
        }
      },
      async onView(row) {
        this.$router.push({
          name: 'UpdateGlobalVariable',
          params: {
            global_variable_id: row._id,
          },
        });
      },
      async onDelete(variable) {
        if (!this.checkPermissionByPermissionName('deleteGlobalVariable')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied. Please contact Owner.',
          });
        } else {
          this.$confirm('Are you sure to delete the Global Variable?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(async () => {
            await this.deleteGlobalVariable(variable);
          });
        }
      },

      assignGlobalVariableType(item) {
        if (item != 'All Categories') {
          this.fetchAllGlobalVariables();
        } else {
          this.fetchAllGlobalVariables();
        }
      },
      onClickPanel(tab) {
        this.loading = true;
        this.selectedTab = tab.name;
        let params = {};
        this.search_string = '';
        if (tab.label != 'All Categories') {
          params['type'] = tab.name;
          this.$router.push({
            path: '/global-variables',
            query: params,
          });
          this.fetchAllGlobalVariables().catch(() => {});
        } else {
          this.$router.push({
            path: '/global-variables',
            query: params,
          });
          this.fetchAllGlobalVariables().catch(() => {});
        }
      },

      async deleteGlobalVariable(data) {
        await this.$store.dispatch('globalVariables/deleteGlobalVariable', {
          id: data._id,
        });

        if (this.getGlobalVariableDeleteStatus) {
          await deleteGlobalVariable(data._id);
          this.currentPage = 1;
          this.$notify.success({
            title: 'Success',
            message: 'Global variable deleted successfully',
          });

          this.fetchAllGlobalVariables();
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getUserDeleteError?.critical_error,
          });
        }
      },

      async fetchAllGlobalVariables() {
        this.loading = true;
        this.data = [];
        let params = {
          page: this.currentPage,
          limit: this.pageSize,
          order_by: 'updated_at',
          order_type: 'desc',
        };
        if (this.search_string) {
          params['search_string'] = this.search_string;
        }
        if (this.selectedTab !== 'All Categories') {
          params['input_type'] = this.selectedTab;
        }
        // await this.$store.dispatch(
        //     "globalVariables/fetchGlobalVariables",
        //     params
        // );
        const getAllGlobalVariables = await fetchGlobalVariables(params);
        this.loading = false;
        this.currentPage = getAllGlobalVariables.page ? parseInt(getAllGlobalVariables.page) : 1;
        this.total = getAllGlobalVariables.total || 0;
        this.data = getAllGlobalVariables.data || [];
      },

      getTabLabelName(type) {
        return type.split('_').join(' ');
      },

      async loadData(data) {
        if (this.data && this.data.length) {
          this.pageSize = data.pageSize ? data.pageSize : 10;
          this.page = data.page;

          await this.fetchAllGlobalVariables();
        }
      },
      searchFilter() {
        let params = {};
        if (this.$route.query.type) {
          params['type'] = this.$route.query.type;
        }
        if (this.search_string) {
          params['search'] = this.search_string;
          this.$router.push({
            path: '/global-variables',
            query: params,
          });
        }
        this.fetchAllGlobalVariables();
      },
      disableSearchButton() {
        if (this.$route.query.search == this.search_string) {
          return true;
        } else if (!this.search_string) {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      // queryType() {
      //     this.assignGlobalVariableType(this.queryType);
      //     this.selectedTab = this.queryType;
      //     this.fetchAllGlobalVariables();
      // },
      search_string: function (val) {
        this.search_string = val;
        this.pageSize = 10;
        this.page = 1;
        this.currentPage = 1;
        this.fetchAllGlobalVariables();
      },
    },
  };
</script>

<style lang="scss" scoped>
  #global-variables-list {
    width: 100%;
    margin: 0 auto;

    .gridCols-4 {
      display: grid;
      grid-template-columns: 1fr;

      @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }

      @media (min-width: 1280px) {
        grid-template-columns: 1fr 1fr 1fr !important;
      }

      @media (min-width: 1919px) {
        grid-template-columns: 1fr 1fr 1fr 1fr !important;
      }
    }

    .single-cell {
      background-clip: border-box;
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.12) !important;
      background: #fff;
      box-shadow: none !important;

      &:hover {
        box-shadow: 0 3px 6px var(--brand-100);
        border: 1px solid var(--brand-300) !important;
      }
    }
  }

  .sidemenu {
    overflow-y: auto;
    scrollbar-width: thin;
    padding-right: 5px;
  }

  .sidemenu::-webkit-scrollbar {
    width: 0.7em;
  }

  .sidemenu::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }

  .sidemenu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f5f5f5;
    background-color: #f5f5f5;
  }

  .doc {
    min-width: 30px;

    &.selected {
      background: green;
    }
  }

  .green {
    color: green;
  }

  .font-17 {
    font-size: 17px;
    cursor: pointer;
  }

  .documents {
    min-height: 200px;
    max-height: 400px;
    overflow: scroll;
  }

  .btn {
    margin-left: 20px;
    height: 32px;
  }

  .el-button--mini.is-circle {
    padding: 8px;
  }

  .new-variable {
    position: relative;
    bottom: 2px;
  }
</style>
